import React from 'react';
import ReactPlayer from 'react-player/lazy';

import { PlayButton } from '@tmap/mmm-style-guide/src/Icon';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const VideoWrapper = styled('div')(({ theme }) => ({
  pointerEvents: 'none',
  background: theme.palette.common.black,
  height: '84px',
  width: '100%',
  borderRadius: '8px',
  '.react-player__preview': {
    borderRadius: '8px',
  },
}));

export function VideoPreview({ media }) {
  return (
    <VideoWrapper>
      <ReactPlayer
        url={media.url}
        light
        playIcon={<PlayButton />}
        width='100%'
        height='100%'
      />
    </VideoWrapper>
  );
}
